import { createAction } from 'redux-actions';
import type { ProcessResultDto } from '@/api-gen/api.schemas';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DialogProcessorActions {
  export const enum Type {
    SET_STORE_RESPONSE_DATA = 'SET_STORE_RESPONSE_DATA',
    RESET_BLOCKS = 'RESET_BLOCKS',
    GET_RESPONSE_DATA = 'GET_RESPONSE_DATA',
    SET_SESSION_ID = 'SET_SESSION_ID'
  }

  export const getResponseData = createAction<{ text: string; speechBase64?: string; start?: string; end?: string }>(
    Type.GET_RESPONSE_DATA
  );

  export const setSessionId = createAction<string>(Type.SET_SESSION_ID);
  export const setResponseDataStore = createAction<ProcessResultDto>(Type.SET_STORE_RESPONSE_DATA);
  export const resetBlocks = createAction(Type.RESET_BLOCKS);
}
